import { useCallback, useEffect, useMemo, useState } from 'react';
import { notManifested } from 'services/shipments.service';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import { useAlert } from 'context/AlertProvider';
import {
  isB2BPrinter,
  isDSVPrinter,
  isStock,
  isWarehouseManager,
} from 'modules/user-has-permission/user-has-permission';

export function useUnmanifestedShipments() {
  const alert = useAlert();
  const [unmanifestedShipments, setUnmanifestedShipments] = useState([]);
  const canRequest = useMemo(
    () =>
      (isB2BPrinter() || isDSVPrinter()) && !isStock() && !isWarehouseManager(),
    [],
  );

  const fetchUnmanifestedShipments = useCallback(async () => {
    try {
      const { data: unmanifestedShipments } = await notManifested();
      setUnmanifestedShipments(unmanifestedShipments);
    } catch (error) {
      alert.current.error(getMessageFromAxiosError(error));
    }
  }, [alert]);

  useEffect(() => {
    (async () => {
      if (canRequest) await fetchUnmanifestedShipments();
    })();
  }, [fetchUnmanifestedShipments, canRequest]);

  return { unmanifestedShipments, fetchUnmanifestedShipments };
}
